import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=3ebe47f6&scoped=true"
import script from "./Service.js?vue&type=script&lang=js&external"
export * from "./Service.js?vue&type=script&lang=js&external"
import style0 from "./Service.scss?vue&type=style&index=0&id=3ebe47f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe47f6",
  null
  
)

export default component.exports